import { Component } from '@angular/core';

@Component({
  templateUrl: './mpaq.component.html',
})
export class MPAQComponent {

}



// WEBPACK FOOTER //
// ./src/app/marketing/mpaq.component.ts